import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {RedEnvelopeFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";

export abstract class ARedEnvelope extends ABusiness {
    readonly icon = () => h(RedEnvelopeFilled, {style: 'color: #a855f7'});
    readonly title = '红包';
    readonly description = '一手用浏览红包提升用户停留时长，另一手用分享红包拉动新增用户，一举两得。';
    readonly implementations = [{value: 'red_envelope', label: '红包'}];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }
}